export default {
  create_qrph: 'Create QR Stand',
  qr_stand_type: 'QR Stand Type',
  qr_stand_name: 'QR Stand Name',
  new_link: 'New Link',
  edit_link: 'Edit Link',
  single_payment_link: 'Single Payment Links',
  batch_payment_link: 'Batch Payment Links',
  batch_link_details: 'Batch Link Details',
  cancel_upload: 'Cancel',
  proceed_upload: 'Proceed',
  duplicate_upload_detected: 'Duplicate Upload Detected',
  tip_1: 'Select payment method and channel then fill-out the payment links details',
  tip_2: 'Download and filled-out the template to create batch links',
  tip_3: 'Upload your filled excel worksheet using the latest template file to submit batch links',
  tip_4: 'Batch create payment links to collect payment from multiple bank accounts/e-wallets, by uploading an excel file.',
  tip_5: 'Create one payment links to collect payment from one specific bank account/e-wallet only.',
  tip_6: 'You are attempting to upload a file that already exists. Please review the file you are uploading to ensure this is the action you intended to perform.',
  active_status: 'Active Status',
  active: 'Active',
  inactive: 'Inactive',
  payment_status: 'Payment Status',
  paid: 'Paid',
  unpaid: 'Unpaid',
  link_id: 'Link ID',
  link_no: 'Link No.',
  title: 'Title',
  amount: 'Amount',
  type: 'Type',
  create_time: 'Create Time',
  complete_time: 'Complete Time',
  remark: 'Remark',
  copy_link: 'Copy Link',
  link_qr: 'Link QR',
  show_qr_code: 'Show QR Code',
  link_info: 'Link Info',
  link_title: 'Link Title',
  order_mode: 'Order Mode',
  fixed_amount: 'Fixed Amount',
  based_on_product: 'Based on Product',
  customer_to_enter: 'Customer to Enter Amount',
  product: 'Product',
  add_another_product: 'Add Another Product',
  add_new_product: 'Add New Product',
  edit_product: 'Edit Product',
  product_info: 'Product Information',
  product_name: 'Product Name',
  price: 'Price',
  quantity: 'Quantity',
  allow_adjust: 'Customer to Adjust',
  image: 'Image',
  payment_description: 'Payment Description',
  customer_info: 'Customer Info',
  collect_customer_info: 'Collect Customer Info',
  customer_name: 'Customer Name',
  customer_email: 'Customer Email',
  customer_mobile: 'Customer Mobile',
  other_info: 'Other Info',
  add_customer_field: 'Custom Field',
  text: 'Text',
  number_only: 'Number Only',
  marked_as_required: 'Marked as required',
  mark_as_optional: 'Mark as optional',
  add_another_field: 'Add another field',
  link_configuration: 'Link Configuration',
  link_type: 'Link Type',
  one_time: 'One-time',
  reusable: 'Reusable',
  max_of_payments_accepted: 'Max of Payments Accepted',
  expiry_time: 'Expiry Time',
  edit_payment_link: 'Edit Payment Link',
  create_payment_link: 'Create Payment Link',
  payment_link_details: 'Payment Link Details',
  download_qr_code: 'Download QR Code',
  checkout_order_id: 'Checkout Order ID',
  transaction_id: 'Transaction ID',
  payment_channel: 'Payment Channel',
  link_details: 'Link Details',
  transactions: 'Transactions',
  other: 'Other',
  custome_field: 'Custome Field',
  time_zone_tips: 'The current time zone is',
  merchant_order_id: 'Merchant Order ID',
  link_expired_tips: 'Link expired',
  reach_payment_limit_tips: 'Reach payment limit',
  both_tips: 'Link expired,and Reach payment limit',
  overview: 'Overview',
  checkout_details: 'Checkout Details',
  transaction_details: 'Transaction Details',
  time_line: 'TimeLine',
  payment_breakdown: 'Payment Breakdown',
  order_amount: 'Order Amount',
  transaction_fee: 'Transaction Fee',
  payment_amount: 'Payment Amount',
  customer_payin_journey: "Customer's Payin Journey",
  delete_product_tips: 'The product will be deleted from the database. Please confirm',
  add_product_or_search_on_list: 'Add product or Search on the list',
  no_more_data: 'No More Data',
  unlimited: 'Unlimited',
  transaction_fee_charge_mode: 'Transaction Fee Charge Mode',
  transaction_fee_charge_mode1: 'Charge to Merchant',
  transaction_fee_charge_mode2: 'Charge to Customer',
  link_icon: 'Link Icon',
  upload_photo: 'Upload Photo',
  available_edits_left: 'Available edits left',
  create_successful_tips: 'Your Payment Link is ready! Share to your customer',
  update_successful_tips: 'Your Payment Link details was updated!',
  field_empty_tips: 'Please fill in the Label Name for Custom Field in Other Info',
  duplicate_label_name: 'Duplicate Label Name',
  label_name: 'Label Name',
  only_successful_transactions: 'Only includes successful transactions',
  branch_code: 'Branch Code',
  branch_name: 'Branch Name',
  payment_success_page: 'Payment Success Page',
  custom_message: 'Custom Message',
  max_file_tips: 'Max file size: 2MB.Please upload again.',
  min_img_resolution: ''
}
